import React from "react"
//import I18n from "i18n-js/index.js.erb"
import BillingPolicyBuilderConstants from "./constants/BillingPolicyBuilderConstants"

class BillingPolicyBalanceForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      capture_balance_lifecycle_event: this.props.capture_balance_lifecycle_event || '',
      capture_balance_time_period: this.props.capture_balance_time_period || '',
      capture_balance_time_value: this.props.capture_balance_time_value || this.props.capture_balance_time_value == 0 ? this.props.capture_balance_time_value : '',
    };

    this.onChange = this.onChange.bind(this);
  }

  /*******************
  * Render functions *
  ********************/

  render() {
    return (
      <div>
        <h5 className="panel-heading-text">{I18n.t('balance')}</h5>
        <div className="balance-inputs" ref="balance-inputs">
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card" style={{ paddingBottom: 19 }}>
                    <h5 className="panel-heading-text">{I18n.t('capture')}</h5>
                    <div className="row">
                      <div className="col-md-6">
                        {this.renderLifecycleEventSection(this.state.capture_balance_lifecycle_event || 'reservation_created', 'capture_balance_lifecycle_event')}
                        {this.renderFieldErrors('capture_balance_lifecycle_event')}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        {this.renderTimePeriodSection(this.state.capture_balance_time_period, this.state.capture_balance_lifecycle_event || 'reservation_created', 'capture_balance_time_period')}
                        {this.renderFieldErrors('capture_balance_time_period')}
                      </div>
                      <div className="col-md-6">
                        {this.renderTimeValueSection(this.state.capture_balance_time_period, this.state.capture_balance_time_value, 'capture_balance_time_value')}
                        {/* {this.renderFieldErrors(this.state, 'capture_balance_time_value')} */}
                        {this.renderFieldErrors('capture_balance_time_value')}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLifecycleEventSection(lifecycle_event, input_name, exclude_check_out_date) {
    if (exclude_check_out_date === true) {
      return (
        <div className="form-group">
          <label>{I18n.t('event')}</label>
          <br />
          {this.props.read_only ? <div>{I18n.t(lifecycle_event)}</div> : <select name={this.inputName('[' + input_name + ']')} value={lifecycle_event || ''} onChange={this.onChange.bind(null, input_name)} className="form-control">
            <option value="reservation_created">{I18n.t('reservation_created')}</option>
            <option value="check_in_date">{I18n.t('check_in')}</option>
          </select>}
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <label>{I18n.t('event')}</label>
          <br />
          {this.props.read_only ? <div>{I18n.t(lifecycle_event)}</div> : <select name={this.inputName('[' + input_name + ']')} value={lifecycle_event || ''} onChange={this.onChange.bind(null, input_name)} className="form-control">
            <option value="reservation_created">{I18n.t('reservation_created')}</option>
            <option value="check_in_date">{I18n.t('check_in')}</option>
            <option value="check_out_date">{I18n.t('check_out')}</option>
          </select>}
        </div>
      );
    }
  }

  renderTimePeriodSection(time_period, lifecycle_event, input_name) {
    return (
      <div className="form-group" style={{ marginBottom: 0 }}>
        <label>{I18n.t('when')}</label>
        <br />
        {this.props.read_only ? <div>{I18n.t(time_period)}</div> : <select name={this.inputName('[' + input_name + ']')} value={time_period || ''} onChange={this.onChange.bind(null, input_name)} className="form-control">
          {this.props.rules[lifecycle_event].indexOf(BillingPolicyBuilderConstants.IMMEDIATELY) == -1 ? null : <option value={BillingPolicyBuilderConstants.IMMEDIATELY}>{I18n.t('immediately')}</option>}
          {this.props.rules[lifecycle_event].indexOf(BillingPolicyBuilderConstants.BEFORE) == -1 || lifecycle_event == 'reservation_created' ? null : <option value={BillingPolicyBuilderConstants.BEFORE}>{I18n.t('before')}</option>}
          {this.props.rules[lifecycle_event].indexOf(BillingPolicyBuilderConstants.AFTER) == -1 ? null : <option value={BillingPolicyBuilderConstants.AFTER}>{this.capitalize(I18n.t('after'))}</option>}
        </select>}
      </div>
    );
  }

  renderTimeValueSection(time_period, time_value, input_name) {
    var capture_balance_value = time_value || time_value == 0 ? time_value : ''
    if (time_period == "Before" || time_period == "After") {
      return (
        <div className="form-group" style={{ marginTop: 0 }}>
          {
            this.props.read_only
              ?
              <div>{time_value} {`${I18n.t('days')}*`}</div>
              :
              <div>
                <label>{`${I18n.t('days')}*`} <span className="ss-help help" title={I18n.t('balance_time_value_helper_text')}></span></label>
                <div className="input-group">
                  <input name={this.inputName('[' + input_name + ']')} value={capture_balance_value} onChange={this.onChange.bind(null, input_name)} type="number" min="1" step="1" className={this.renderFieldClasses("capture_balance_time_value") + " " + "days-input text-right"} />
                </div>
              </div>
          }
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        if (error) {
          idx = idx + 1;
          return <li key={idx}><b>&#x2022;</b> {error}</li>;
        }
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      )
    }
  }

  renderFieldClasses(field) {
    var classname = 'form-control';
    if (this.props.errors && Object.keys(this.props.errors).length && this.props.errors[field]) {
      classname = classname + ' has-errors';
    }
    return classname;
  }

  /******************
  * Change handlers *
  *******************/

  onChange(name, event) {
    var value = event.target.value;
    this.state[name] = value;
    this.setState(this.state, () => {
      if (typeof this.props.onChange == 'function') {
        this.props.onChange(name, { target: { value: value } });
      }
    });
  }

  /*******************
  * Helper functions *
  ********************/

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  inputName(name, obj) {
    var inputName = 'billing_policy';

    inputName = inputName + name;

    return inputName;
  }

}

export default BillingPolicyBalanceForm